"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateStampRollUpdate = exports.validateStampRollCreate = exports.validateStampAssignment = exports.stampRollSchema = void 0;
var _joi = _interopRequireDefault(require("joi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const stampRollSchemaServer = {
  user_id: _joi.default.number().required(),
  company_id: _joi.default.number().required(),
  active: _joi.default.alternatives().try(_joi.default.number().valid(0, 1), _joi.default.boolean()).label("Active Stamp Roll")
};
const stampRollSchema = exports.stampRollSchema = {
  id: _joi.default.number().min(1).required(),
  prefix: _joi.default.string().allow("").uppercase().trim(),
  received_at: _joi.default.date().label("Receive Date").required(),
  from: _joi.default.number().min(1).label("Stamp Start").required(),
  to: _joi.default.number().min(_joi.default.ref("from")).label("Stamp End").required().messages({
    "number.min": "Stamp roll must end in a larger value than the start"
  })
};
const validateStampRollCreate = (stamp, {
  isServer = false
}) => {
  let schemaToValidate = {
    ...stampRollSchema
  };
  delete schemaToValidate["id"];
  if (isServer) {
    schemaToValidate = {
      ...schemaToValidate,
      ...stampRollSchemaServer
    };
  }
  return _joi.default.object(schemaToValidate).validateAsync(stamp, {
    convert: true,
    stripUnknown: true
  });
};
exports.validateStampRollCreate = validateStampRollCreate;
const validateStampRollUpdate = (stamp, {
  isServer = false
}) => {
  let schemaToValidate = {
    ...stampRollSchema
  };
  if (isServer) {
    schemaToValidate = {
      active: stampRollSchemaServer.active
    };
  }
  return _joi.default.object(schemaToValidate).validateAsync(stamp, {
    convert: true,
    stripUnknown: true
  });
};
exports.validateStampRollUpdate = validateStampRollUpdate;
const validateStampAssignment = assignment => {
  const schema = {
    roll_id: _joi.default.number().min(1).required(),
    note: _joi.default.string().allow("").uppercase().trim(),
    from: _joi.default.number().min(1).label("Stamp Start").required(),
    to: _joi.default.number().min(_joi.default.ref("from")).label("Stamp End").required()
  };
  return _joi.default.object(schema).validateAsync(assignment, {
    convert: true,
    stripUnknown: true
  });
};
exports.validateStampAssignment = validateStampAssignment;